import { route } from 'ziggy-js'

export function ziggyRoute(name, args = null) {
  return route(name, args, false)
}
